var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "elevatorNavigationStyle" },
    [
      _c("h2", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticStyle: {
            color: "#969799",
            "font-size": "12px",
            "margin-top": "10px",
          },
        },
        [_vm._v("\n    拖动选中的导航可对其排序\n  ")]
      ),
      _vm._v(" "),
      _c("section", { staticClass: "block" }, [
        _c("h3", { staticClass: "block-title" }, [_vm._v("导航内容")]),
        _vm._v(" "),
        _vm.datas.imageList[0]
          ? _c(
              "div",
              { staticClass: "imgListWrap" },
              [
                _c(
                  "vuedraggable",
                  _vm._b(
                    {
                      model: {
                        value: _vm.datas.imageList,
                        callback: function ($$v) {
                          _vm.$set(_vm.datas, "imageList", $$v)
                        },
                        expression: "datas.imageList",
                      },
                    },
                    "vuedraggable",
                    _vm.dragOptions,
                    false
                  ),
                  [
                    _c(
                      "transition-group",
                      _vm._l(_vm.datas.imageList, function (item, index) {
                        return _c(
                          "section",
                          { key: index, staticClass: "imgList" },
                          [
                            _c("i", {
                              staticClass: "el-icon-circle-close",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteimg(index)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.datas.navigationType !== 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "imag",
                                    class: {
                                      "imag-empty": !item.src,
                                      "is-mixed":
                                        _vm.datas.navigationType === 0,
                                    },
                                    on: {
                                      click: function ($event) {
                                        item.src
                                          ? ""
                                          : _vm.showUpload("item-" + index)
                                      },
                                    },
                                  },
                                  [
                                    item.src
                                      ? _c("img", {
                                          attrs: {
                                            draggable: "false",
                                            src: _vm.resPath + item.src,
                                            alt: "",
                                          },
                                        })
                                      : [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-picture-outline",
                                          }),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("点击上传")]),
                                        ],
                                    _vm._v(" "),
                                    item.src
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "imag-replace",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.showUpload(
                                                  "item-" + index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-refresh",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "imgText",
                                class: {
                                  "imgText-full":
                                    _vm.datas.navigationType !== 0,
                                },
                              },
                              [
                                _vm.datas.navigationType !== 2
                                  ? _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入标题，也可不填",
                                        size: "mini",
                                      },
                                      model: {
                                        value: item.text,
                                        callback: function ($$v) {
                                          _vm.$set(item, "text", $$v)
                                        },
                                        expression: "item.text",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "select-type" },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "请选择跳转位置",
                                          size: "mini",
                                        },
                                        model: {
                                          value: item.location,
                                          callback: function ($$v) {
                                            _vm.$set(item, "location", $$v)
                                          },
                                          expression: "item.location",
                                        },
                                      },
                                      _vm._l(
                                        _vm.navigationList,
                                        function (nav) {
                                          return _c("el-option", {
                                            key: nav.value,
                                            attrs: {
                                              label: nav.name,
                                              value: nav.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _c("div", { staticClass: "empty-tip" }, [
              _vm._v("暂无导航项，点击下方按钮添加"),
            ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-row" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "", size: "small" },
                on: { click: _vm.addNavItem },
              },
              [_c("i", { staticClass: "el-icon-plus" }), _vm._v(" 添加导航")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { "label-width": "80px", model: _vm.datas, size: "small" } },
        [
          _c(
            "section",
            { staticClass: "block" },
            [
              _c("h3", { staticClass: "block-title" }, [_vm._v("导航样式")]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "lef", attrs: { label: "导航类型" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "nav-type-group",
                      model: {
                        value: _vm.datas.navigationType,
                        callback: function ($$v) {
                          _vm.$set(_vm.datas, "navigationType", $$v)
                        },
                        expression: "datas.navigationType",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: 0 } }, [
                        _vm._v("混合"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: 1 } }, [
                        _vm._v("文字"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: 2 } }, [
                        _vm._v("图片"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "lef", attrs: { label: "文字高度" } },
                [
                  _c("el-slider", {
                    attrs: {
                      max: 50,
                      min: 24,
                      "input-size": "mini",
                      "show-input": "",
                    },
                    model: {
                      value: _vm.datas.textHeight,
                      callback: function ($$v) {
                        _vm.$set(_vm.datas, "textHeight", $$v)
                      },
                      expression: "datas.textHeight",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "lef", attrs: { label: "文字大小" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      placeholder: "请输入文字大小",
                      maxlength: 2,
                    },
                    model: {
                      value: _vm.datas.textSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.datas, "textSize", _vm._n($$v))
                      },
                      expression: "datas.textSize",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "lef", attrs: { label: "显示位置" } },
                [
                  _c("div", { staticClass: "weiz" }, [
                    _c("i", {
                      class: [
                        "zdy-icon",
                        "icon-font-left",
                        _vm.datas.positions == "left" ? "active" : "",
                      ],
                      on: {
                        click: function ($event) {
                          _vm.datas.positions = "left"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("i", {
                      class: [
                        "zdy-icon",
                        "icon-font-center",
                        _vm.datas.positions == "center" ? "active" : "",
                      ],
                      on: {
                        click: function ($event) {
                          _vm.datas.positions = "center"
                        },
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "lef",
                  attrs: {
                    label: "下划线",
                    prop: "underline",
                    "hide-required-asterisk": true,
                  },
                },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.datas.underline,
                      callback: function ($$v) {
                        _vm.$set(_vm.datas, "underline", $$v)
                      },
                      expression: "datas.underline",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "block" },
            [
              _c("h3", { staticClass: "block-title" }, [_vm._v("图片样式")]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "lef borrediu", attrs: { label: "图片倒角" } },
                [
                  _c("el-slider", {
                    attrs: { max: 50, "input-size": "mini", "show-input": "" },
                    model: {
                      value: _vm.datas.borderRadius,
                      callback: function ($$v) {
                        _vm.$set(_vm.datas, "borderRadius", $$v)
                      },
                      expression: "datas.borderRadius",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "lef", attrs: { label: "背景图片" } },
                [
                  _c("div", { staticClass: "shop-head-pic" }, [
                    _vm.datas.bgImg
                      ? _c("img", {
                          staticClass: "home-bg",
                          attrs: {
                            src: _vm.resPath + _vm.datas.bgImg,
                            alt: "",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "shop-head-pic-btn" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              plain: "",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showUpload("1")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "el-icon-plus" }),
                            _vm._v("更换"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.clear()
                              },
                            },
                          },
                          [_vm._v("清空")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "block" },
            [
              _c("h3", { staticClass: "block-title" }, [_vm._v("颜色")]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "lef", attrs: { label: "背景颜色" } },
                [
                  _c("el-color-picker", {
                    staticClass: "picke",
                    attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                    model: {
                      value: _vm.datas.backgroundColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.datas, "backgroundColor", $$v)
                      },
                      expression: "datas.backgroundColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "lef", attrs: { label: "文字颜色" } },
                [
                  _c("el-color-picker", {
                    staticClass: "picke",
                    attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                    model: {
                      value: _vm.datas.textColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.datas, "textColor", $$v)
                      },
                      expression: "datas.textColor",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("uploadImg", {
        ref: "upload",
        on: { uploadInformation: _vm.uploadInformation },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }